export const checkNotificationIsAvailable = () => 'Notification' in window;

export const requestPermission = async () => Notification.requestPermission();

export const getNotification = ({ options, title = "" }: { options: NotificationOptions; title?: string }) =>
  new Notification(title, options);
